var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { getBettingHistory as getBettingHistoryAction, clearBetHistory as clearBetHistoryAction } from '../../actions/betting-history/creators/bettingHistory';
import Date from '../shared/newDate/Date.jsx';
import DateRange from '../shared/newDate/DateRange.jsx';
import moment from 'moment';
import Single from './Single';
import Complex from './Complex';
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import * as BetType from '../../constants/BetType';
import { Helmet } from 'react-helmet';
import * as LoadingStateMap from '../../constants/loading';
import { withRouter } from 'react-router-dom';
var messages = defineMessages({
    page_title: {
        id: 'betting_history_title',
        defaultMessage: 'История ставок'
    },
    show_btn: {
        id: 'betting_history_show',
        defaultMessage: 'Показать'
    },
    no_bets: {
        id: 'betting_history_no_data',
        defaultMessage: 'За выбранный период ставок не найдено'
    },
    history_bets_type_active: {
        id: 'history_bets_type_active',
        defaultMessage: 'Today'
    },
    history_bets_type_today: {
        id: 'history_bets_type_today',
        defaultMessage: 'Today'
    },
    history_bets_type_yesterday: {
        id: 'history_bets_type_yesterday',
        defaultMessage: 'Yesterday'
    },
    history_bets_type_on_date: {
        id: 'history_bets_type_on_date',
        defaultMessage: 'On Date'
    },
    history_bets_type_for_period: {
        id: 'history_bets_type_for_period',
        defaultMessage: 'For Period'
    },
    betting_history_on_date: {
        id: 'betting_history_on_date',
        defaultMessage: 'Выберите желаемый период'
    },
    betting_history_on_period: {
        id: 'betting_history_on_period',
        defaultMessage: 'Выберите желаемую дату'
    }
});
var BettingHistory = /** @class */ (function (_super) {
    __extends(BettingHistory, _super);
    function BettingHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            filterItems: [
                { msg: 'history_bets_type_active', value: 'active' },
                { msg: 'history_bets_type_today', value: 'today' },
                { msg: 'history_bets_type_yesterday', value: 'yesterday' },
                { msg: 'history_bets_type_on_date', value: 'date' },
                { msg: 'history_bets_type_for_period', value: 'period' },
            ],
            filterType: 'active',
            dateFrom: moment().startOf('day'),
            dateTo: moment().endOf('day'),
            gamblerId: 0,
            accountId: 0
        };
        _this.onDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day'),
                dateTo: moment(date).endOf('day'),
            });
        };
        _this.startDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day')
            });
        };
        _this.endDateChange = function (date) {
            _this.setState({
                dateTo: moment(date).endOf('day')
            });
        };
        _this.onDateSelectHandle = function (e) {
            var period = e.target.value;
            switch (period) { //eslint-disable-line default-case
                case 'today':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false,
                        dateFrom: moment().startOf('day'),
                        dateTo: moment().endOf('day'),
                    });
                    _this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
                    break;
                case 'yesterday':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false
                    });
                    _this.onSubmit(moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
                    break;
                case 'period':
                    _this.setState({
                        dateFrom: moment().subtract(6, 'day').startOf('day'),
                        dateTo: moment().endOf('day'),
                    });
                    _this.props.clearBetHistoryAction();
                    break;
                case 'date':
                    _this.setState({
                        dateFrom: moment().startOf('day'),
                        dateTo: moment().endOf('day'),
                    });
                    _this.props.clearBetHistoryAction();
                    break;
                default:
                    _this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'), 'active');
                    _this.props.clearBetHistoryAction();
            }
            _this.setState({
                filterType: e.target.value
            });
        };
        _this.onSubmit = function (startDate, finishDate, filterType) {
            var data = {
                startDate: startDate,
                finishDate: finishDate,
                languageId: _this.props.languageId
            };
            _this.props.getBettingHistoryAction(data, filterType);
        };
        return _this;
    }
    BettingHistory.prototype.componentDidMount = function () {
        var _a = this.state, dateFrom = _a.dateFrom, dateTo = _a.dateTo, filterType = _a.filterType;
        var startDate = moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss');
        var finishDate = moment(dateTo).format('YYYY-MM-DDTHH:mm:ss');
        this.onSubmit(startDate, finishDate, filterType);
    };
    BettingHistory.prototype.render = function () {
        var _this = this;
        var _a = this.state, filterItems = _a.filterItems, filterType = _a.filterType, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
        var _b = this.props, betsData = _b.betsData, languageId = _b.languageId, intl = _b.intl;
        var pageTitle = intl.formatMessage(messages.page_title);
        var details = betsData.data;
        var loadingState = betsData.loadingState;
        var items = [];
        details.map(function (item, i) {
            switch (item.StakeType) {
                case BetType.SINGLE:
                    items.push(_jsx(Single, { betsDataItem: item, languageId: languageId }, i));
                    break;
                case BetType.EXPRESS:
                case BetType.ANTIEXPRESS:
                case BetType.SYSTEM:
                    items.push(_jsx(Complex, { betsDataItem: item, languageId: languageId }, i));
            }
        });
        var startDate = moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss');
        var finishDate = moment(dateTo).format('YYYY-MM-DDTHH:mm:ss');
        var showDatePicker = filterType === 'period' || filterType === 'date';
        var isLoading = loadingState === LoadingStateMap.FETCHING;
        var dateRangeProps = {
            languageId: languageId,
            dateFrom: moment().subtract(6, 'day').startOf('day').format('DD.MM.YYYY'),
            dateTo: moment().format('DD.MM.YYYY'),
            endDateChange: this.endDateChange,
            startDateChange: this.startDateChange
        };
        return (_jsxs("div", __assign({ id: 'content' }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 ", pageTitle] }) }), _jsxs("div", __assign({ className: 'backward backward--history' }, { children: [_jsx("div", { className: 'back', onClick: this.props.history.goBack }), _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.page_title)) })) }))] })), _jsxs("div", __assign({ className: 'block blc_history blc_info history' }, { children: [_jsxs("div", __assign({ className: 'history__filter' }, { children: [_jsx("div", __assign({ className: 'history__filter__items' }, { children: filterItems.map(function (item) {
                                        var cls = item.value === filterType ? 'history__filter__item history__filter__item--active' : 'history__filter__item';
                                        return (_createElement(FormattedMessage, __assign({}, messages[item.msg], { key: item.value }), function (message) { return _jsx("button", __assign({ value: item.value, className: cls, onClick: _this.onDateSelectHandle }, { children: message })); }));
                                    }) })), showDatePicker &&
                                    _jsxs("div", __assign({ className: 'history__filter__datepick' }, { children: [filterType === 'date' && _jsx(Date, { onDateChange: this.onDateChange, languageId: languageId, dateFrom: dateFrom }), filterType === 'period' && _jsx(DateRange, __assign({}, dateRangeProps)), _jsx("button", __assign({ onClick: function () { return _this.onSubmit(startDate, finishDate); }, disabled: isLoading, className: "history__filter__datepick__btn ".concat(isLoading ? 'loading' : '') }, { children: _jsx(FormattedMessage, __assign({}, messages.show_btn)) }))] }))] })), (filterType === 'date' && loadingState === LoadingStateMap.INIT) &&
                            _jsx("div", __assign({ className: 'items no-bets' }, { children: _jsx(FormattedMessage, __assign({}, messages.betting_history_on_date)) })), (filterType === 'period' && loadingState === LoadingStateMap.INIT) &&
                            _jsx("div", __assign({ className: 'items no-bets' }, { children: _jsx(FormattedMessage, __assign({}, messages.betting_history_on_period)) })), (loadingState === LoadingStateMap.FETCHED && items.length > 0) &&
                            _jsx("div", __assign({ className: 'items' }, { children: items })), (loadingState === LoadingStateMap.FETCHED && items.length === 0) &&
                            _jsx("div", __assign({ className: 'items no-bets' }, { children: _jsx(FormattedMessage, __assign({}, messages.no_bets)) }))] }))] })));
    };
    return BettingHistory;
}(React.Component));
BettingHistory.propTypes = {
    languageId: PropTypes.number.isRequired,
    getBettingHistoryAction: PropTypes.func.isRequired,
    clearBetHistoryAction: PropTypes.func.isRequired,
    betsData: PropTypes.any.isRequired
};
var mapToState = function (state) { return ({
    betsData: state.application.get('bets'),
    languageId: state.application.get('languageId')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getBettingHistoryAction: getBettingHistoryAction,
    clearBetHistoryAction: clearBetHistoryAction
}, dispatch); };
export default withRouter(connect(mapToState, mapDispatchToProps)(injectIntl(BettingHistory)));



// WEBPACK FOOTER //
// ./src/components/betting-history/Index.jsx